import moment from 'moment';
import "moment-timezone";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import React, { useState, useEffect, useRef } from 'react';
import { DownOutlined, UpOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Empty, message, Typography, Collapse, Spin, Card, Divider, Row, Col, Popover, Pagination } from 'antd'
import RelatedMeetingPopup from '../Popup/RelatedMeetingPopup'
import { FetchAllAttendeeList } from '../../../Api/Services/CommonApiService'
import { fetchAllMeeting, fetchAllMeeting1 } from "../../../Api/Services/MeetingApiService"
import { PaperPlaneSendIcon, PaperPlaneReciveIcon } from '../../../components/Icons/Icons';
import CustomHtmlParser from '../Email/CustomHtmlParser'

const { Text } = Typography;
const { Panel } = Collapse;

const EmailTable = ({ UrlId, NacTrigger, setNaCTrigger, profile, type, refreshTrigger, tabKey }) => {
    const PAGE_SIZE = 20;
    const isClickingRef = useRef(false);
    const skipOnChangeRef = useRef(false);
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const localData = useSelector((state) => state.localRedux);
    const companyProfile = localData.company
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const [upComming, setUpcomming] = useState()
    const [allMeeting, setAllMeeting] = useState()
    const [emailPopup, setMeetingPopup] = useState(false)
    const [emailOpenId, setMeetingOpenId] = useState()
    const [allattendeeData, setAllattendeeData] = useState()
    const [isOpen10, setIsOpen10] = useState(false);
    const [openPage, setOpenPage] = useState(Array(allMeeting?.length).fill(false));
    const [loadingPage, setLoadingPage] = useState(false);
    const [apiPage, setApiPage] = useState();
    const [tablePage, setTablePage] = useState();
    const [totalCount, setTotalCount] = useState([])
    const [apiType, setApiType] = useState()
    const mergeUniqueById = (existing = [], incoming = [], idKey = 'meetingActivityId') => {
        const seen = new Set(existing.map(item => item[idKey]));
        return [...existing, ...incoming.filter(item => !seen.has(item[idKey]))];
    };
    const handleOpenPageChange = (index) => {
        const newPopoverOpenStates = [...openPage];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage(newPopoverOpenStates);
    };
    const emailClose = () => {
        setMeetingPopup(false)
        setMeetingOpenId()
        setNaCTrigger("CallBack")
    }
    const ViewDetailPage = (id, userId, type) => {
        if (profile?.userId === userId) {
            if (!emailactiontype && emailapiValues?.emailType === type) {
                setMeetingPopup(true)
                setMeetingOpenId(id)
                setNaCTrigger("trigger")
            }
            else {
                message.info("Unable to retrieve the selected meeting. Please check your email settings or contact the administrator for support")
            }
        } else {
            message.info("Meeting details not found. Please contact your admin for details")
        }
    }
    const parseDateTime = (dateTime) => {
        return new Date(dateTime);
    };
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2})/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    const OutLookDateTimeForTimeZone = (dateTime) => {
        const DateTime = `${dateTime.replace(/\.\d+/, "")}.000Z`;
        const formatedDateTime = moment(DateTime, "YYYY-MM-DDTHH:mm:ss.Z").utc().format("YYYY-MM-DDTHH:mm:ss.000000");
        return formatedDateTime;
    }
    const ZohoDateTimeForTimeZone = (dateTime) => {
        const formatedDateTime = moment(dateTime, "YYYYMMDDTHHmmssZ").utc().format("YYYY-MM-DDTHH:mm:ss.000000");
        return formatedDateTime;
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = "YYYY-MM-DD";
        const timeFormat = "24hrs";
        const formattedDate = converted.format(dateFormat);
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${formattedTime}`
    }
    function formatTimeDifference(startDateTime, endDateTime) {
        const start = new Date(startDateTime);
        const end = new Date(endDateTime);
        const diffMs = end - start;
        const diffMinutes = diffMs / (1000 * 60);
        const hours = Math.floor(diffMinutes / 60);
        const minutes = diffMinutes % 60;
        if (hours > 0) {
            return `${hours}h ${minutes}m`;
        }
        return `${minutes}m`;
    }
    const formatDateTimeData = (CreateDate) => {
        const createdTime = new Date(CreateDate);
        const currentTime = new Date(currentrealTime);
        const timeDifference = Math.floor((currentTime - createdTime) / (1000 * 60));
        const days = Math.floor(timeDifference / 1440);
        const formattedDate = createdTime.toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric"
        });
        return days < 1 ? "Today" : formattedDate;
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const formattedDate = date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
        });
        const timezoneCorrectedDate = new Date(formattedDate);
        const year = timezoneCorrectedDate.getFullYear();
        const month = String(timezoneCorrectedDate.getMonth() + 1).padStart(2, '0');
        const day = String(timezoneCorrectedDate.getDate()).padStart(2, '0');
        const hours = String(timezoneCorrectedDate.getHours()).padStart(2, '0');
        const minutes = String(timezoneCorrectedDate.getMinutes()).padStart(2, '0');
        const formattedCustom = `${year}-${month}-${day} ${hours}:${minutes}`;
        return formattedCustom;
    };
    function convertFromUTCAndFormat(dateTime, profile) {
        if (!dateTime || !profile?.timeZone) return "";
        // Extract IANA time zone name from full label like "(GMT+5:30) Asia/Kolkata"
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }
        // Step 1: Parse original and convert to UTC
        const utcTime = moment.parseZone(dateTime).utc();
        // Step 2: Convert UTC to desired profile time zone
        const converted = utcTime.clone().tz(toTimezone);
        // Step 3: Apply formats
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat); // Assume this handles 12/24-hour format
        return { date: converted.format(dateFormat), time: formattedTime };
    }
    function convertFromUTCAndFormat1(dateTime, profile) {
        if (!dateTime || !profile?.timeZone) return "";

        // Extract IANA time zone name from full label like "(GMT+5:30) Asia/Kolkata"
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };

        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }

        // ✅ Step 1: Parse directly as UTC
        const utcTime = moment.utc(dateTime);

        // ✅ Step 2: Convert to desired profile time zone
        const converted = utcTime.clone().tz(toTimezone);

        // ✅ Step 3: Format date and time
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormatPref = (profile?.timeFormat?.toLowerCase() === "12hrs" || profile?.timeFormat?.toLowerCase() === '12-hour') ? "h:mm A" : "HH:mm";

        return {
            date: converted.format(dateFormat),
            time: converted.format(timeFormatPref)
        };
    }
    const timeadnDate = (dateTime) => {
        const [date, time] = dateTime.split(" ");
        // const formattedDate = profile?.dateFormate ? moment(date).format(profile.dateFormate) : moment(date).format("YYYY-MM-DD");
        const formattedDate = date;
        const formattedTime = convertTime(moment(time, "HH:mm:ss").format("HH:mm:ss"), profile.timeFormat ? profile.timeFormat : "24hrs");
        return { date: formattedDate, time: formattedTime };
    }
    function convertFromUTCAndFormatForDifferent(dateTime, profile, dateFormat, type) {
        if (!dateTime || !profile?.timeZone) return "";

        // Extract IANA time zone name from label like "(GMT+5:30) Asia/Kolkata"
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };

        const toTimezone = extractTimezoneName(profile.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }

        // Step 1: Parse input and convert to UTC
        const utcTime = moment.parseZone(dateTime).utc();

        // Step 2: Convert UTC to target timezone
        const converted = utcTime.clone().tz(toTimezone);

        // Step 3: Return formatted output
        const formattedDate = converted.format(dateFormat);
        const formattedTime = converted.format('h:mm a');

        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const rawTime = converted.format("HH:mm");
        const formattedTime1 = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${type === "1" ? formattedTime1 : formattedTime}`;
    }
    function convertFromUTCAndFormatForDifferent1(dateTime, profile, dateFormat, type) {
        if (!dateTime || !profile?.timeZone) return "";

        // Extract IANA time zone name from label like "(GMT+5:30) Asia/Kolkata"
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };

        const toTimezone = extractTimezoneName(profile.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }

        // ✅ Step 1: Parse directly as UTC (since input is already UTC)
        const utcTime = moment.utc(dateTime);

        // ✅ Step 2: Convert UTC to target timezone
        const converted = utcTime.clone().tz(toTimezone);

        // ✅ Step 3: Format date and time
        const formattedDate = converted.format(dateFormat);
        const formattedTime = converted.format('h:mm a');

        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const rawTime = converted.format("HH:mm");
        const formattedTime1 = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${type === "1" ? formattedTime1 : formattedTime}`;
    }
    function formatAttendees(attendeeList, hostEmail, configEmail, apiAttendeesList, linkby) {
        if (!Array.isArray(attendeeList)) return null;
        const attendeeData = [];
        const includedEmails = new Set();
        const filteredAttendees = attendeeList.filter(attendee => attendee.email !== hostEmail && !attendee.organizer);
        filteredAttendees.forEach(att => {
            const email = att.address || att.email
            if (!email) return;

            const apiMatch = apiAttendeesList.find(
                apiUser => apiUser.email === email
            );

            if (apiMatch && !includedEmails.has(email)) {
                attendeeData.push(apiMatch);
                includedEmails.add(email);
            }
        });
        if (configEmail && configEmail !== hostEmail && !includedEmails.has(configEmail) && linkby === profile?.userId) {
            attendeeData.push({
                id: profile?.userId || null,
                name: `${profile?.firstName || ''} ${profile?.lastName || ''}`.trim() || configEmail,
                email: configEmail,
                type: 'Users'
            });
        }
        return attendeeData;
    }
    function formatAttendees2(attendeeList, hostEmail, configEmail, apiAttendeesList, linkby) {
        if (!Array.isArray(attendeeList)) return null;
        const attendeeData = [];
        const includedEmails = new Set();
        const filteredAttendees = attendeeList.filter(attendee => attendee.email !== hostEmail);
        filteredAttendees.forEach(att => {
            const email = att.address || att.email
            if (!email) return;

            const apiMatch = apiAttendeesList.find(
                apiUser => apiUser.email === email
            );

            if (apiMatch && !includedEmails.has(email)) {
                attendeeData.push(apiMatch);
                includedEmails.add(email);
            }
        });
        if (configEmail && configEmail !== hostEmail && !includedEmails.has(configEmail) && linkby === profile?.userId) {
            attendeeData.push({
                id: profile?.userId || null,
                name: `${profile?.firstName || ''} ${profile?.lastName || ''}`.trim() || configEmail,
                email: configEmail,
                type: 'Users'
            });
        }
        return attendeeData;
    }
    function formatAttendees3(attendeeList, hostEmail, configEmail, apiAttendeesList, linkby) {
        if (!Array.isArray(attendeeList)) return null;
        const attendeeData = [];
        const includedEmails = new Set();
        if (!Array.isArray(attendeeList)) return null;
        const filteredAttendees = attendeeList.filter(attendee => attendee.emailAddress.address !== hostEmail);
        filteredAttendees.forEach(att => {
            const email = att.emailAddress.address || att.emailAddress.email
            if (!email) return;

            const apiMatch = apiAttendeesList.find(
                apiUser => apiUser.email === email
            );

            if (apiMatch && !includedEmails.has(email)) {
                attendeeData.push(apiMatch);
                includedEmails.add(email);
            }
        });
        if (configEmail && configEmail !== hostEmail && !includedEmails.has(configEmail) && linkby === profile?.userId) {
            attendeeData.push({
                id: profile?.userId || null,
                name: `${profile?.firstName || ''} ${profile?.lastName || ''}`.trim() || configEmail,
                email: configEmail,
                type: 'Users'
            });
        }
        return attendeeData;
    }
    function getOrganizerFrom(id, type, dataList) { // address
        const filtered = dataList.filter(item => item.type === type);
        return filtered.find(item => item.id === id) || { name: "Not Available", email: "Not Available" };
    }
    function getOrganizerFromEmail(email, type, dataList) {
        const filtered = dataList.filter(item => item.type === type);
        return filtered.find(item => item.email === email) || { name: "Not Available", email: "Not Available" };
    }
    const getattendeeFrom = (type, fromEmail, dataList) => {
        const users = dataList.filter(item => item.type === type);
        const user = users.find(u => u.email === fromEmail);
        const name = user?.name?.trim();
        // const validData = name || fromEmail;
        const validData = name || "Not Available";
        return validData
    };
    async function RecentActivity2() {
        try {
            const data = await fetchAllMeeting1(UrlId[1], apiType);
            setTotalCount(data)
        } catch (error) {
            message.error(error);
        }
    }
    async function AllMeetings(page) {
        try {
            if (type !== "List") { setLoadingPage(true) }
            const data = type !== "List" ? await fetchAllMeeting(UrlId[1], apiType, page) : await fetchAllMeeting1(UrlId[1], apiType);
            const FormatedData = await Promise.all(data?.map(async (meeting) => {
                const { entityId, entityType, meetingNotes, configurationType, dateAndTime, meetingActivityId, sourceId, subject, linkedBy, actionType, actionDate, meetingDetail } = meeting;
                let formattedFromDate;
                let formattedFromTime;
                let formattedToDate;
                let formattedToTime;
                let StartDateTimeDif;
                let EndDateTimeDif;
                let FromAddress;
                let ToAddress;
                if (configurationType === "Google") {
                    if (actionType === "organizer") {
                        if (entityType === "Lead" || entityType === "Contact") {
                            const origanizerdata = getOrganizerFrom(entityId, `${entityType}s`, allattendeeData, meetingDetail?.organizer.email)
                            FromAddress = origanizerdata?.name || origanizerdata?.email
                        }
                        else {
                            const origanizerdata = meetingDetail ? getOrganizerFromEmail(meetingDetail?.organizer.email, "Contacts", allattendeeData) : { name: null, email: meetingDetail?.organizer.email }
                            FromAddress = origanizerdata?.name || origanizerdata?.email
                        }
                    }
                    if (actionType === "attendee") {
                        FromAddress = emailapiValues?.email === meetingDetail?.organizer?.email ?
                            `${profile?.firstName} ${profile?.lastName}` : getattendeeFrom("User", meetingDetail?.organizer?.email, allattendeeData)
                    }
                    const attendeeString = formatAttendees(meetingDetail?.attendees, meetingDetail?.organizer?.email, emailapiValues?.email, allattendeeData, meeting.linkedBy);
                    ToAddress = attendeeString
                    const sDateTime = convertFromUTCAndFormatForDifferent(dateAndTime?.start?.dateTime, profile, "MM/DD/YYYY", "0")
                    const EDateTime = convertFromUTCAndFormatForDifferent(dateAndTime?.end?.dateTime, profile, "MM/DD/YYYY", "0")
                    const startTimeDate = convertFromUTCAndFormat(dateAndTime?.start?.dateTime, profile)
                    const endTimeDate = convertFromUTCAndFormat(dateAndTime?.end?.dateTime, profile)
                    StartDateTimeDif = sDateTime
                    EndDateTimeDif = EDateTime
                    formattedFromDate = startTimeDate.date
                    formattedFromTime = startTimeDate.time
                    formattedToDate = endTimeDate.date
                    formattedToTime = endTimeDate.time
                }
                else if (configurationType === "Outlook") {
                    if (actionType === "organizer") {
                        if (entityType === "Lead" || entityType === "Contact") {
                            const origanizerdata = getOrganizerFrom(entityId, `${entityType}s`, allattendeeData, meetingDetail?.organizer?.emailAddress?.address)
                            FromAddress = origanizerdata.name || origanizerdata.email
                        }
                        else {
                            const origanizerdata = meetingDetail ? getOrganizerFromEmail(meetingDetail?.organizer?.emailAddress?.address, "Contacts", allattendeeData) : { name: null, email: meetingDetail?.organizer?.emailAddress?.address }
                            FromAddress = origanizerdata.name || origanizerdata.email
                        }
                    }
                    if (actionType === "attendee") {
                        FromAddress = emailapiValues?.email === meetingDetail?.organizer?.emailAddress?.address ?
                            `${profile?.firstName} ${profile?.lastName}` : getattendeeFrom("User", meetingDetail?.organizer?.emailAddress?.address, allattendeeData)
                        // ((meetingDetail?.organizer?.emailAddress?.name && meetingDetail?.organizer?.emailAddress?.name !== "") ?meetingDetail?.organizer?.emailAddress?.name : meetingDetail?.organizer?.emailAddress?.address)
                    }
                    const attendeeString = formatAttendees3(meetingDetail?.attendees, meetingDetail?.organizer?.emailAddress?.address, emailapiValues?.email, allattendeeData, meeting.linkedBy);
                    ToAddress = attendeeString
                    const startFrom = OutLookDateTimeForTimeZone(dateAndTime?.start?.dateTime)
                    const endTo = OutLookDateTimeForTimeZone(dateAndTime?.end?.dateTime)
                    const sDateTime = convertFromUTCAndFormatForDifferent1(startFrom, profile, "MM/DD/YYYY", "0")
                    const EDateTime = convertFromUTCAndFormatForDifferent1(endTo, profile, "MM/DD/YYYY", "0")
                    const startTimeDate = convertFromUTCAndFormat1(startFrom, profile)
                    const endTimeDate = convertFromUTCAndFormat1(endTo, profile)
                    StartDateTimeDif = sDateTime
                    EndDateTimeDif = EDateTime
                    formattedFromDate = startTimeDate.date
                    formattedFromTime = startTimeDate.time
                    formattedToDate = endTimeDate.date
                    formattedToTime = endTimeDate.time
                }
                else if (configurationType === "Zoho") {
                    if (actionType === "organizer") {
                        if (entityType === "Lead" || entityType === "Contact") {
                            const origanizerdata = getOrganizerFrom(entityId, `${entityType}s`, allattendeeData, meetingDetail?.organizer)
                            FromAddress = origanizerdata.name || origanizerdata.email
                        }
                        else {
                            const origanizerdata = meetingDetail ? getOrganizerFromEmail(meetingDetail?.organizer, "Contacts", allattendeeData) : { name: null, email: meetingDetail?.organizer }
                            FromAddress = origanizerdata.name || origanizerdata.email
                        }
                    }
                    if (actionType === "attendee") {
                        FromAddress = emailapiValues?.email === meetingDetail?.organizer ?
                            `${profile?.firstName} ${profile?.lastName}` : getattendeeFrom("User", meetingDetail?.organizer, allattendeeData)
                    }
                    const attendeeString = formatAttendees2(meetingDetail?.attendees, meetingDetail?.organizer, emailapiValues?.email, allattendeeData, meeting.linkedBy);
                    ToAddress = attendeeString
                    const startFrom = ZohoDateTimeForTimeZone(dateAndTime?.start)
                    const endTo = ZohoDateTimeForTimeZone(dateAndTime?.end)
                    const sDateTime = convertFromUTCAndFormatForDifferent1(startFrom, profile, "MM/DD/YYYY", "0")
                    const EDateTime = convertFromUTCAndFormatForDifferent1(endTo, profile, "MM/DD/YYYY", "0")
                    const startTimeDate = convertFromUTCAndFormat1(startFrom, profile)
                    const endTimeDate = convertFromUTCAndFormat1(endTo, profile)
                    StartDateTimeDif = sDateTime
                    EndDateTimeDif = EDateTime
                    formattedFromDate = startTimeDate.date
                    formattedFromTime = startTimeDate.time
                    formattedToDate = endTimeDate.date
                    formattedToTime = endTimeDate.time
                }
                return {
                    actionType,
                    actionDate,
                    linkedBy,
                    StartDateTime: StartDateTimeDif,
                    EndDateTime: EndDateTimeDif,
                    startDate: formattedFromDate,
                    startTime: formattedFromTime,
                    endDate: formattedToDate,
                    endTime: formattedToTime,
                    type: configurationType,
                    activityId: meetingActivityId,
                    meetingId: sourceId,
                    title: subject,
                    FromAddress,
                    ToAddress,
                    meetingNotes
                }
            }));
            if (type !== "List") {
                if (page === 1) {
                    setAllMeeting(FormatedData);
                } else {
                    setAllMeeting((prev) => {
                        const merged = mergeUniqueById(prev, FormatedData);
                        return merged;
                    });
                }
                setLoadingPage(false);
            }
            else {
                const currentDateTime = new Date(currentrealTime);
                const upcomming = FormatedData.filter(item => {
                    const startDateTime = parseDateTime(item.StartDateTime);
                    const endDateTime = parseDateTime(item.EndDateTime);
                    return (startDateTime <= currentDateTime && endDateTime >= currentDateTime) || startDateTime > currentDateTime;
                });
                setUpcomming(upcomming)
            }
        } catch (error) {
            if (type !== "List") { setLoadingPage(true) }
            message.error(error);
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await FetchAllAttendeeList()
            setAllattendeeData(data)
        }
        catch (error) {
            setAllattendeeData([])
            message.error(error)
        }
    }
    useEffect(() => {
        if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
            setApiType("Lead")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
            setApiType("Deal")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
            setApiType("Contact")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
            setApiType("Account")
        }
        UserDetailsApi()
    }, [])
    const reFetchData = async () => {
        await Promise.allSettled([
            setApiPage(1),
            setTablePage(1),
            AllMeetings(1),
            RecentActivity2(),
        ])
    }
    const reFetchData1 = async () => {
        await Promise.allSettled([
            AllMeetings(apiPage),
            RecentActivity2(),
        ])
    }
    useEffect(() => {
        if (allattendeeData) {
            if (type !== "List") {
                if (refreshTrigger === tabKey) {
                    if (NacTrigger !== "trigger") {
                        reFetchData()
                    }
                }
            } else {
                AllMeetings()
            }
        }
    }, [UrlId, NacTrigger, allattendeeData, refreshTrigger, tabKey, isOpen10])
    const handleExpand10 = (key) => {
        setIsOpen10(key.length > 0);
    };
    const [expandedItems, setExpandedItems] = useState({});
    const toggleExpand = (key) => {
        setExpandedItems(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };
    const handleTableChange = async (page) => {
        if (skipOnChangeRef.current) {
            skipOnChangeRef.current = false;
            return;
        }
        const newTablePage = page;
        if (newTablePage === tablePage) {
            return;
        }
        setTablePage(newTablePage);
        const maxIndexNeeded = newTablePage * PAGE_SIZE;
        if (allMeeting.length < maxIndexNeeded) {
            skipOnChangeRef.current = false;
            const nextApiPage = apiPage + 1;
            AllMeetings(nextApiPage);
            setApiPage(nextApiPage);
        }
        else {
            setApiPage(newTablePage);
        }
    };
    const handleTableChange2 = async (pagination, navigationType) => {
        skipOnChangeRef.current = true;
        if (isClickingRef.current) return;
        setTablePage(pagination);
        const maxIndexNeeded = pagination * PAGE_SIZE;
        if (allMeeting.length < maxIndexNeeded) {
            isClickingRef.current = true;
            const nextApiPage = apiPage + 1;
            AllMeetings(nextApiPage);
            setApiPage(nextApiPage);
        }
        else {
            const nextApiPage = navigationType === "prev" ? apiPage - 1 : apiPage + 1
            setApiPage(nextApiPage);
        }
        skipOnChangeRef.current = false;
    };
    const sortedActivities = type === "Collaspe" ? allMeeting
        ?.sort((a, b) => {
            const dateA = a.actionDate ? moment(convertAndFormatDateTime(a.actionDate, companyProfile, profile), "YYYY-MM-DD HH:mm") : null;
            const dateB = b.actionDate ? moment(convertAndFormatDateTime(b.actionDate, companyProfile, profile), "YYYY-MM-DD HH:mm") : null;
            if (!dateA || !dateB) return 0;
            return dateB - dateA;
        }) : [];
    const paginatedActivities = type === "Collaspe" ? sortedActivities?.slice(
        (tablePage - 1) * PAGE_SIZE,
        tablePage * PAGE_SIZE) : [];
    useEffect(() => {
        if (isClickingRef.current && allMeeting) {
            isClickingRef.current = false;
        }
    }, [allMeeting]);
    return (
        <>
            {type === "Collaspe" ?
                (loadingPage ?
                    <div className="spin">
                        <Spin />
                    </div>
                    : (paginatedActivities?.length > 0 ?
                        <div>
                            {paginatedActivities?.map((item, index) => {
                                const convertsDate = item.actionDate ? convertAndFormatDateTime(item.actionDate, companyProfile, profile) : item.actionDate;
                                const CorrectActionDate = formatDate(convertsDate)
                                const action = convertsDate ? timeadnDate(CorrectActionDate) : { date: "", time: "" };
                                const formattedTimeDifference = action.date && action.date !== "" ? formatDateTimeData(action.date) : ""
                                const FullTime = formatTimeDifference(item.StartDateTime, item.EndDateTime)
                                return (
                                    <div key={index} style={{ marginBottom: 15 }}>
                                        <Card className="DetailsTabCard">
                                            <Collapse bordered={false} className="DetailsTabCollapse">
                                                <Panel
                                                    header={
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            {item.actionType === "attendee" ? <PaperPlaneSendIcon height={16} width={16} marginRight={5} /> :
                                                                item.actionType === "organizer" ? <PaperPlaneReciveIcon height={16} width={16} marginRight={5} /> : ""}
                                                            <Text strong title={item.title && item.title !== "" ? item.title : "(No Subject)"}>
                                                                {item?.title ? item?.title.length > 30 ? `${item.title.slice(0, 30)}...` : item.title : "(No Subject)"}
                                                            </Text>
                                                        </div>
                                                    }
                                                    key="1"
                                                    extra={<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            <FeatherIcon icon="clock" size={16} style={{ marginRight: 5 }} />{formattedTimeDifference}, {action.time}
                                                        </div>
                                                        <Popover
                                                            placement="bottom"
                                                            content={
                                                                <div >
                                                                    <Link to={combinedUrl} className="text_icon" onClick={() => { ViewDetailPage(item.meetingId, item.linkedBy, item.type); handleOpenPageChange(index) }}>
                                                                        <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                    </Link>
                                                                </div>
                                                            }
                                                            trigger="hover"
                                                            open={openPage[index]}
                                                            onOpenChange={() => handleOpenPageChange(index)}
                                                        >
                                                            <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                        </Popover>
                                                    </div>}
                                                >
                                                    <Divider style={{ margin: 0 }} />
                                                    <div style={{ marginTop: 10 }}>
                                                        <Text type="secondary">{item.meetingNotes && item.meetingNotes !== "" ? <CustomHtmlParser html={item.meetingNotes} key={index} page="Previewss" /> : "Meeting Description"}</Text>
                                                    </div>
                                                    <Row gutter={16} style={{
                                                        marginTop: 10,
                                                        borderRadius: 15,
                                                        border: "1px solid #dddddd"
                                                    }}>
                                                        <Col span={8} style={{ borderRight: "1px solid #dddddd", padding: "5px 10px" }}>
                                                            <Text type="secondary" className='RightSide-Lable'>Host</Text>
                                                            <br />
                                                            <div className='div-ellipsis' title={item.FromAddress}>{item.FromAddress}</div>
                                                        </Col>
                                                        <Col span={10} style={{ borderRight: "1px solid #dddddd", padding: "5px 10px" }}>
                                                            <Text type="secondary" className='RightSide-Lable'>Meeting date and time</Text>
                                                            <br />
                                                            {item.startDate} {item.startTime}, {FullTime}
                                                        </Col>
                                                        <Col span={6} style={{ padding: "5px 10px" }}>
                                                            <Text type="secondary" className='RightSide-Lable'>Invitee <InfoCircleOutlined title='The list below shows CRM users who were included in the meeting invite. To view the full list of invitees, please click ‘View Details’' />
                                                                {/* {item.actionType === "organizer" ? <InfoCircleOutlined style={{ fontSize: "small", color: '#0000009c', cursor: 'pointer', margin: "0px" }}
                                                        title={
                                                            UrlId !== undefined && UrlId !== null && UrlId[0] === "?CASE" ?
                                                                "The details below reflect only the case assignee at the time the meeting was received. To view all recipients, click 'View Details'" :
                                                                `The details below reflect only the ${UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD" ? "lead" :
                                                                    UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT" ? "contact" :
                                                                        UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL" ? 'contact' :
                                                                            UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT" ? 'contact' : ''} owner at the time the meeting was received. To view all recipients, click 'View Details'`}
                                                    /> : ""} */}
                                                            </Text>
                                                            <br />
                                                            {item.ToAddress?.length > 0 ? (
                                                                <>
                                                                    {(expandedItems[index] ? item.ToAddress : item.ToAddress.slice(0, 3)).map((attendee, i) => (
                                                                        <div className='div-ellipsis' key={i} title={attendee.name?.trim() || attendee.email}>
                                                                            {attendee.name?.trim() || attendee.email}
                                                                        </div>
                                                                    ))}

                                                                    {item.ToAddress.length > 3 && !expandedItems[index] && (
                                                                        <span
                                                                            role="button"
                                                                            tabIndex={0}
                                                                            style={{ color: "#1890ff", cursor: "pointer" }}
                                                                            onClick={() => toggleExpand(index)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === "Enter" || e.key === " ") {
                                                                                    toggleExpand(index);
                                                                                }
                                                                            }}
                                                                        >
                                                                            ...more
                                                                        </span>
                                                                    )}

                                                                    {item.ToAddress.length > 3 && expandedItems[index] && (
                                                                        <span
                                                                            role="button"
                                                                            tabIndex={0}
                                                                            style={{ color: "#1890ff", cursor: "pointer" }}
                                                                            onClick={() => toggleExpand(index)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === "Enter" || e.key === " ") {
                                                                                    toggleExpand(index);
                                                                                }
                                                                            }}
                                                                        >
                                                                            show less
                                                                        </span>
                                                                    )}
                                                                </>
                                                            ) : "Not Available"}
                                                        </Col>
                                                    </Row>
                                                </Panel>
                                            </Collapse>
                                        </Card>
                                    </div>
                                )
                            })}
                            <div style={{ textAlign: "center", marginBottom: 10 }}>
                                <Pagination
                                    current={tablePage}
                                    pageSize={PAGE_SIZE}
                                    total={allMeeting.length}
                                    onChange={handleTableChange}
                                    showSizeChanger={false}
                                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${totalCount.length} items`}
                                    itemRender={(page, type, originalElement) => {
                                        if (type === 'prev') {
                                            const isDisabled = tablePage <= 1;
                                            return (
                                                <span role="button"
                                                    tabIndex={0}
                                                    className={`customeTable-pagianion ${isDisabled ? 'disabled' : ''}`}
                                                    style={{
                                                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                        opacity: isDisabled ? 0.4 : 1,
                                                        display: 'inline-flex',
                                                        alignItems: 'center'
                                                    }}
                                                    onKeyDown={(event) => {
                                                        if ((event.key === 'Enter' || event.key === ' ') && !isDisabled) {
                                                            if (!isDisabled) handleTableChange2(tablePage - 1, "prev")
                                                        }
                                                    }}
                                                    onClick={(e) => {
                                                        if (!isDisabled) handleTableChange2(tablePage - 1, "prev");
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    <FeatherIcon icon="chevron-left" size={16} style={{ marginTop: 5 }} />
                                                </span>
                                            );
                                        }

                                        if (type === 'next') {
                                            const isDisabled = (tablePage * PAGE_SIZE) >= totalCount.length || isClickingRef.current;
                                            return (
                                                <span role="button"
                                                    tabIndex={0}
                                                    className={`customeTable-pagianion ${isDisabled ? 'disabled' : ''}`}
                                                    style={{
                                                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                        opacity: isDisabled ? 0.4 : 1,
                                                        display: 'inline-flex',
                                                        alignItems: 'center'
                                                    }}
                                                    onKeyDown={(event) => {
                                                        if ((event.key === 'Enter' || event.key === ' ') && !isDisabled) {
                                                            if (!isDisabled) handleTableChange2(tablePage + 1, "next")
                                                        }
                                                    }}
                                                    onClick={(e) => {
                                                        if (!isDisabled) handleTableChange2(tablePage + 1, "next");
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    <FeatherIcon icon="chevron-right" size={16} style={{ marginTop: 5 }} />
                                                </span>
                                            );
                                        }

                                        return originalElement; // normal page numbers
                                    }}
                                />
                            </div>
                        </div> :
                        <div style={{ padding: "10%" }}>
                            <Empty />
                        </div>)) :
                <>
                    <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand10} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end" >
                        <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", }}><div style={{ fontWeight: 600 }}>Upcoming Activity<span style={{ background: "#f0f0f0", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: 500, marginLeft: "10px", }}>{upComming?.length || 0}</span></div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen10 ? "Close" : "View"}</Text></div>} key="1">
                            {upComming?.sort((a, b) => {
                                const dateA = a.actionDate ? moment(convertAndFormatDateTime(a.actionDate, companyProfile, profile), "YYYY-MM-DD HH:mm") : null;
                                const dateB = b.actionDate ? moment(convertAndFormatDateTime(b.actionDate, companyProfile, profile), "YYYY-MM-DD HH:mm") : null;
                                if (!dateA || !dateB) return 0;
                                return dateA - dateB;
                            }).map((item, index) => {
                                const FullTime = formatTimeDifference(item.StartDateTime, item.EndDateTime)
                                return (
                                    <div className='RightSide-DataShadow' key={index}>
                                        <div className='Right-side-divs'>
                                            <Text type="secondary" className='RightSide-Lable'>Subject</Text> <br />
                                            <Text className='ListNavigate2' onClick={() => ViewDetailPage(item.meetingId, item.linkedBy, item.type)}>{item.title && item.title !== "" ? item.title : "(No Subject)"}</Text>
                                        </div>
                                        <div className='Right-side-divs'>
                                            <Text type="secondary" className='RightSide-Lable'>Host</Text> <br />
                                            <div className='div-ellipsis' title={item.FromAddress}>{item.FromAddress}</div>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Meeting Date</Text> <br />
                                                <Text >{item.startDate}</Text>
                                            </div>
                                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Meeting Time</Text> <br />
                                                <Text >{item.startTime}, {FullTime}</Text>
                                            </div>
                                        </div>
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Invitee</Text> <br />
                                            {item.ToAddress?.length > 0 && (
                                                <>
                                                    {(expandedItems[index] ? item.ToAddress : item.ToAddress.slice(0, 3)).map((attendee, i) => (
                                                        <div className='div-ellipsis' key={i} title={attendee.name?.trim() || attendee.email}>
                                                            {attendee.name?.trim() || attendee.email}
                                                        </div>
                                                    ))}

                                                    {item.ToAddress.length > 3 && !expandedItems[index] && (
                                                        <span
                                                            role="button"
                                                            tabIndex={0}
                                                            style={{ color: "#1890ff", cursor: "pointer" }}
                                                            onClick={() => toggleExpand(index)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    toggleExpand(index);
                                                                }
                                                            }}
                                                        >
                                                            ...more
                                                        </span>
                                                    )}

                                                    {item.ToAddress.length > 3 && expandedItems[index] && (
                                                        <span
                                                            role="button"
                                                            tabIndex={0}
                                                            style={{ color: "#1890ff", cursor: "pointer" }}
                                                            onClick={() => toggleExpand(index)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    toggleExpand(index);
                                                                }
                                                            }}
                                                        >
                                                            show less
                                                        </span>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>)
                            })}
                        </Panel>
                    </Collapse>
                </>}
            <RelatedMeetingPopup modelOpen={emailPopup} handleClose={emailClose} Meeting={emailOpenId} emailCongifDetail={emailapiValues} type="Meeting" reFetchData1={reFetchData1} />
        </>
    );
}
EmailTable.propTypes = {
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(EmailTable)